import $$ from 'cmn-utils'

const baseUrl = "/api/prospect/task-device/";
export default {
    submit: (params) => {
        return $$.post(baseUrl + 'submit', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
}